import $ from 'jquery';

export default function () {

  var trackDownloads = {
    _href: '',
    _pathname: '',
    _event: null,
    _element: null,

    getUrl: function () {
      return this._href;
    },

    getPayload: function ( props ) {
      return Object.assign({
          eventCategory: 'DocsLib',
          eventAction: 'Download',
          eventLabel: this._pathname
        },
        props
      );
    },

    isIE: function () {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf('MSIE ');
      return msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);
    },

    pushEvent: function () {

      window.ga('send', 'event', this.getPayload({ transport: 'beacon' }));

      return true;
    },

    queueEvent: function () {

      window.ga('send', 'event', this.getPayload({
        hitCallbak: function (url) {
          window.location.href = url;
        }(this._href)
      }));

      return false;
    },

    __init: function ($) {

      var _this = this;

      $('a.document-link').on('click', function (e) {

        _this._element = this;
        _this._event = e;
        _this._href = _this._element.href;
        _this._pathname = _this._element.pathname;

        /**
         * Due to unsupported `document` attribute and `beacon` transport mode
         * in Internet Explorer, we place a workaround.
         * If browser is Internet Explorer, prevent default behaviour, and
         * trigger custom tracking + requeueing of event
         */
        if (_this.isIE()) {
          e.preventDefault();

          return _this.queueEvent();
        }

        return _this.pushEvent();
      });
    }
  };

  trackDownloads.__init($);

}
